module.exports = require('bindings')('ed25519');
